import type { AssetsSegmentSchemaPatched } from '@iconik-io/iconik-api/src/schema_patched/assets_segments';

import { segmentColors } from './constants';

import styles from './segment_color_marker.module.css';

export type SegmentColorMarkerProps = {
  segment?: AssetsSegmentSchemaPatched;
};

export function SegmentColorMarker({ segment }: SegmentColorMarkerProps) {
  const colorLabel = segmentColors.find(
    (item) => item.value === segment?.segment_color,
  )?.label;
  return (
    <div
      className={styles.color}
      style={{ background: segment?.segment_color }}
      aria-label={`${colorLabel ?? 'Default'} comment marker`}
      role="status"
    />
  );
}
